import { Suspense, lazy } from 'react'

import Loader from '@space-core/components/loader'
import ErrorBoundary from '@space-shell/common/components/errorBoundary'
import { AuthStatus, useAuthContext } from '@space-shell/common/contexts/auth'
import { useMembershipStore } from '@space-shell/core/store'

const TrendingPosts = lazy(() => import('@space-shell/pages/community/trendingPosts'))

const CommunitiesInHome = () => {
  const { authStatus } = useAuthContext()
  const { membershipData } = useMembershipStore()
  const isUserAuthenticated = authStatus === AuthStatus.AUTHENTICATED

  // TODO: Verify that the user has access to community to render this component and avoid 403 errors
  if (!isUserAuthenticated || !membershipData?.hasCommunity) {
    return null
  }

  return (
    <div
      data-test='communities-in-home'
      className='_px-4 _px-md-10 _py-6 _py-md-10 _border-top _border-gray-200'>
      <ErrorBoundary>
        <Suspense fallback={<Loader full />}>
          <TrendingPosts />
        </Suspense>
      </ErrorBoundary>
    </div>
  )
}

export default CommunitiesInHome
